import { SourceData } from 'pages/ListManagement/types';
import { cdmApi } from '.';

const PREFIX = '/list';

export interface IList {
    id: number;
    name: string;
    type: string;
    is_private: boolean;
    retailers: number[];
    frequency: string;
    is_active: boolean;
    type_unique: boolean;
    upc_type: string;
    has_all_products: boolean;
    columns: string[];
    data: SourceData;
}

export interface IListType {
    id: number;
    name: string;
}

const usersApi = cdmApi.injectEndpoints({
    endpoints: (builder) => ({
        getLists: builder.query<{ lists: IList[] }, { idTool: number }>({
            query: (params) => ({ url: `${PREFIX}/`, method: 'get', params }),
            providesTags: ['Lists'],
        }),
        getListType: builder.query<{ lists: IListType[] }, { idTool: number }>({
            query: (params) => ({ url: `${PREFIX}/list-type`, method: 'get', params }),
        }),
        getListData: builder.query<{ lists: IList[] }, { idTool: number; idList: number }>({
            query: (params) => ({ url: `${PREFIX}/`, method: 'get', params }),
            providesTags: ['List'],
        }),
        updateListData: builder.mutation<{ lists: IList[] }, { idTool: number; list: IList }>({
            query: (data) => ({ url: `${PREFIX}/update`, method: 'put', data }),
            invalidatesTags: ['List'],
            onQueryStarted(list, { dispatch, queryFulfilled }) {
                const res = dispatch(
                    usersApi.util.updateQueryData('getLists', { idTool: list.idTool }, (draft) => {
                        const draftRef = draft;
                        const newListData = draftRef.lists.map((data) => {
                            if (list.list.id === data.id) {
                                return list.list;
                            }
                            return data;
                        });
                        draftRef.lists = newListData;
                    }),
                );

                queryFulfilled.catch(() => {
                    res.undo();
                });
            },
        }),
        addListData: builder.mutation<{ lists: IList[] }, { idTool: number; lists: IList }>({
            query: (data) => ({ url: `${PREFIX}/add`, method: 'post', data }),
            invalidatesTags: ['Lists', 'List'],
        }),
        deleteList: builder.mutation<void, { idTool: number; idList: number }>({
            query: (data) => ({ url: `${PREFIX}/delete`, method: 'delete', data }),
            onQueryStarted(list, { dispatch, queryFulfilled }) {
                const res = dispatch(
                    usersApi.util.updateQueryData('getLists', { idTool: list.idTool }, (draft) => {
                        const draftRef = draft;
                        const newListData = draftRef.lists.filter((data) => {
                            return list.idList !== data.id;
                        });
                        draftRef.lists = newListData;
                    }),
                );

                queryFulfilled.catch(() => {
                    res.undo();
                });
            },
        }),
    }),
    overrideExisting: false,
});

export const {
    useLazyGetListDataQuery,
    useGetListsQuery,
    useGetListTypeQuery,
    useGetListDataQuery,
    useUpdateListDataMutation,
    useAddListDataMutation,
    useDeleteListMutation,
} = usersApi;
